import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useContextApi } from "../../../context/ContextApi";
import uRLs from "../../../utils/baseUtils";
import { toPrimaryQuantity, toSecondaryQuantity } from "@heartinz/finance";
import { useAuth } from "../../../context/AuthProvider";
import { handleUnitNameSelect } from "../../../utils/unitUtils";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { DeleteIcon, XIcon } from "../../../constants/Icons";

const StockOut = ({ data, onEdit, onClose, isBtnLoading }) => {
  const [inputValue, setInputValue] = useState("");
  const [remarks, setRemarks] = useState("");
  const {settings}=useAuth();
  const [unitData,setUnitData]=useState();
  const [errorMessage, setErrorMessage] = useState({
    quanity: "",
    remarks: "",
  });
  const inputRef = useRef(null);
  const remarksRef = useRef(null);
  const [selectedUnit,setSelectedUnit]=useState()
  const handleUpdateRef = useRef(null);
  const {useEscapeKey}=useContextApi();
  useEscapeKey(onClose)
  // console.log(data)
  useEffect(() => {
    // setInputValue(data.stockLeft || 1);
    setInputValue("");
    setErrorMessage("");
    setRemarks("");
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [data.stockLeft]);

  const handleUnitName=(unitData)=>{
    handleUnitNameSelect(unitData,settings);
  }

 

  const stockValue = Number(data?.isSecondaryUnit
  ? secondaryQuanity(data.stockLeft, data.unitConfig)
  : data.stockLeft ||0);

  const handleUpdate = () => {

    const parsedQuantity =
      uRLs.UNIT === "true" && data?.unitConfig
        ? parseFloat(inputValue)
        : parseInt(inputValue, 10);
  
    // empty / invalid
    if (
      inputValue === "" ||
      isNaN(parsedQuantity) ||
      parsedQuantity <= 0
    ) {
      setErrorMessage((prev) => ({
        ...prev,
        quanity: "Enter a valid quantity greater than 0.",
      }));
  
      inputRef.current?.focus();
      return;
    }
  
    // check selected unit
    const isSecondarySelected =
      selectedUnit === data?.unitConfig?.secondaryUnitCode;
  
    // calculate max stock properly
    let currentStockValue = Number(data?.stockLeft || 0);
  
    if (
      uRLs.UNIT === "true" &&
      data?.unitConfig &&
      isSecondarySelected
    ) {
      const secondaryQtyData = toSecondaryQuantity(
        data.stockLeft,
        data.unitConfig
      );
  
      currentStockValue = Number(
        secondaryQtyData?.secondaryQty || 0
      );
    }
  
    // max validation
    if (parsedQuantity > currentStockValue) {
      setErrorMessage((prev) => ({
        ...prev,
        quanity: currentStockValue === 0
        ? "Out of stock. No stock available."
        : `Maximum quantity allowed is ${currentStockValue}.`,
      }));
  
      inputRef.current?.focus();
      return;
    }
  
    // clear error
    setErrorMessage((prev) => ({
      ...prev,
      quanity: "",
    }));
  console.log(selectedUnit)
    onEdit(data, parsedQuantity, remarks,selectedUnit);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "inputValue") {
  
      if (value === "") {
        setInputValue("");
        return;
      }
  
      // check currently selected unit
      const isPrimarySelected =
        selectedUnit === data?.unitConfig?.primaryUnitCode;
  
      const isSecondarySelected =
        selectedUnit === data?.unitConfig?.secondaryUnitCode;
  
      // validation based on selected unit
      const regex =
        uRLs.UNIT === "true" && data?.unitConfig
          ? isSecondarySelected
            ? /^\d*\.?\d{0,1}$/ // secondary -> 1 decimal
            : /^\d*\.?\d{0,3}$/ // primary -> 3 decimals
          : /^\d*$/;
  
      if (!regex.test(value)) return;
  
      const parsedValue = parseFloat(value);
  
      // FIXED STOCK VALUE
      let currentStockValue = data?.stockLeft || 0;
    
      if (
        uRLs.UNIT === "true" &&
        data?.unitConfig &&
        isSecondarySelected
      ) {
        const secondaryQtyData = toSecondaryQuantity(
          data.stockLeft,
          data.unitConfig
        );
    
        currentStockValue = Number(
          secondaryQtyData?.secondaryQty || 0
        );
      }
    
      // compare properly
      if (!isNaN(parsedValue) && parsedValue > currentStockValue) {
        setInputValue(String(currentStockValue));
    
        setErrorMessage((prev) => ({
          ...prev,
          quanity:  currentStockValue === 0
          ? "Out of stock. No stock available."
          : `Maximum quantity allowed is ${currentStockValue}.`,
        }));
    
        return;
      }
    
      setInputValue(value);
    
      setErrorMessage((prev) => ({
        ...prev,
        quanity: "",
      }));
    }
  
    if (name === "remarks") {
      setRemarks(value);
  
      setErrorMessage((prev) => ({
        ...prev,
        remarks: "",
      }));
    }
  };

  const handleUnitConversion=(unitName,type)=>{

    if (unitName === selectedUnit) return;
    
    setSelectedUnit(unitName)
    if(uRLs.UNIT==="true"){
    let quanity = data?.stockLeft||0;
    if(type==="p"){
      const secondaryQuantity=toSecondaryQuantity(quanity,data?.unitConfig);
        const primaryQuantity=toPrimaryQuantity(secondaryQuantity.secondaryQty,data?.unitConfig)
        
        setInputValue(0)
        // setInputValue(Number(primaryQuantity.primaryQty))
    }
      
  else if(type==="s"){
      const secondaryQuantity=toSecondaryQuantity(quanity,data?.unitConfig);

      setInputValue(0)
      // setInputValue(Number(secondaryQuantity.secondaryQty))
  }
    }
  }
  
  // const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();

  //     const trimmedData = String(inputValue || "").trim();

  //     if (!trimmedData) {
  //       setErrorMessage((prev) => ({
  //         ...prev,
  //         [fieldName]: "Enter a valid quantity greater than 0.",
  //       }));
  //       return;
  //     }

  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [fieldName]: "",
  //     }));

  //     if (isLast) {
  //       handleUpdate();
  //     } else if (
  //       nextRef?.current &&
  //       typeof nextRef.current.focus === "function"
  //     ) {
  //       nextRef.current.focus();
  //     }
  //   }
  // };

  const handleEnterFocus = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const isQuantityField = e.target === inputRef.current;
      if (isQuantityField) {
        const trimmedData = String(inputValue || "").trim();
        const parsedValue = parseFloat(trimmedData);

        if (!trimmedData || isNaN(parsedValue) || parsedValue <= 0) {
          setErrorMessage((prev) => ({
            ...prev,
            quanity: "Enter a valid quantity greater than 0.",
          }));
          return;
        }

        setErrorMessage((prev) => ({
          ...prev,
          quanity: "",
        }));
      }

      nextRef?.current?.focus();
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmedValue = String(e.target.value || "").trim();
      // if (!trimmedValue) {
      //   setErrorMessage((prev) => ({
      //     ...prev,
      //     remarks: "This field should not be empty.",
      //   }));
      //   return;
      // }

      setErrorMessage((prev) => ({
        ...prev,
        remarks: "",
      }));
      handleUpdate(e);
    }
  };

  useEffect(() => {
    setInputValue(String(stockValue || ""));
    setErrorMessage({
      quanity: "",
      remarks: "",
    });
    setRemarks("");
  
    setSelectedUnit(
      data?.isSecondaryUnit
        ? data?.unitConfig?.secondaryUnitCode
        : data?.unitConfig?.primaryUnitCode
    );
  
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
    const name=handleUnitName(data?.unitConfig)
    setUnitData({...data?.unitConfig,
      primaryUnitName:name?.primaryUnitName,
      secondaryUnitName:name?.secondaryUnitName,
    })
  }, [data]);

  useEffect(()=>{
    setSelectedUnit(data.isSecondaryUnit?data?.unitConfig?.secondaryUnitCode:data?.unitConfig?.primaryUnitCode)
  },[data?.unitConfig])

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Trash Stock</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {/* <div className="modal-body">
              <h6 className="text-center">{data.productid.title}</h6>
              <h6 className="mx-2">
                <small>Available Stock - </small>
                &nbsp;
                <span className="badge bg-label-kids">{data.stockLeft}</span>
              </h6>
              <div className="d-flex justify-content-center align-items-center my-3">
                <input
                  type="text"
                  name="inputValue"
                  value={inputValue}
                  ref={inputRef}
                  onFocus={(e) => e.target.select()}
                  onChange={handleInputChange}
                  className="form-control text-center mx-2"
                  // style={{ width: "120px" }}
                  onKeyDown={(e) =>
                    handleEnterFocus(e,remarksRef)
                  }
                />
              </div>
               {errorMessage.quanity && (
                <div className="text-danger text-center mt-2">
                  {errorMessage.quanity}
                </div>
              )}
              <h6 className="mx-2">
                <small>Remarks </small>
              </h6>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <input
                  type="text"
                  name="remarks"
                  value={remarks}
                  ref={remarksRef}
                  onFocus={(e) => e.target.select()}
                  onChange={handleInputChange}
                  className="form-control  mx-2"
                  // style={{ width: "120px" }}
                  onKeyDown={(e) =>
                    handlePaymodeKeyDown(e)
                  }
                />
              </div>
              {errorMessage.remarks && (
                <div className="text-danger text-center mt-2">
                  {errorMessage.remarks}
                </div>
              )}
            </div> */}
            <div className="modal-body">
              <h6 className="text-center">{data.title}</h6>
              <h6 className="text-center">
                <small>Available Stock - </small>
                <span className="badge bg-label-kids">{Number(data?.isSecondaryUnit
                                ? secondaryQuanity(data.stockLeft,data?.unitConfig)
                                : data?.stockLeft)}{" "}
                                <span className="font-11 ms-1">
                                {(() => {
                                            const unitCode = data?.isSecondaryUnit
                                                ? data?.unitConfig?.secondaryUnitCode
                                                : data?.unitConfig?.primaryUnitCode;

                                            return unitCode !== "unit" ? unitCode : "";
                                            })()}
                                            </span></span>
              </h6>
              <div className="card w-100 radius-10 mb-0">
                <div className="card-body">
                  <form className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        Quantity <small className="text-danger">*</small>
                      </label>
                      <div className="input-group">
                      <input 
                        type="text"
                        name="inputValue"
                        value={inputValue}
                        ref={inputRef}
                        onFocus={(e) => e.target.select()}
                        onChange={handleInputChange}
                        className="form-control"
                        // style={{ width: "120px" }}
                        onKeyDown={(e) => handleEnterFocus(e, remarksRef)}
                      />
                      {(uRLs.UNIT==="true" && unitData?.primaryUnitCode) && (
                       <div className="d-flex text-start ">
                    <button
                          
                          className="btn btn-unit shadow-none  border-end-0 rounded-end-0 rounded-start-0  dropdown-toggle-split"
                          id="printreceiptbtn"
                          data-bs-toggle="dropdown"
                        >
                          {selectedUnit}
                        </button>
                    <button
                          type="button" 
                          className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          // style={{ borderRight: "2px solid #fff" }}
                        />
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                         <li>
                           <button
                           type="button"
                             className={`dropdown-item ${
                               selectedUnit === unitData?.primaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              //  setSelectedUnit(unitData?.primaryUnitCode);
                              inputRef.current.select();
                               handleUnitConversion(unitData.primaryUnitCode,'p')
                             }}
                           >
                             {unitData.primaryUnitName} ({unitData.primaryUnitCode})
                           </button>
                         </li>
                         {unitData.secondaryUnitCode && (
                         <li>
                           <button
                            type="button"
                             className={`dropdown-item ${
                               selectedUnit === unitData?.secondaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              //  setSelectedUnit(unitData?.secondaryUnitCode);
                              inputRef.current.select();
                               handleUnitConversion(unitData?.secondaryUnitCode,'s')
                             }}
                           >
                             {unitData?.secondaryUnitName} ({unitData?.secondaryUnitCode})
                           </button>
                         </li>
                         )}
                     </ul>
                        </div>)}
                      </div>
                      {errorMessage?.quanity && (
                        <small className="text-danger">
                          {errorMessage.quanity}
                        </small>
                      )}
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="description" className="form-label">
                        Remarks 
                      </label>
                      <textarea
                        type="text"
                        autoComplete="off"
                        maxLength="5000"
                        className="form-control"
                        name="remarks"
                        value={remarks}
                        ref={remarksRef}
                        onFocus={(e) => e.target.select()}
                        onChange={handleInputChange}
                        // style={{ width: "120px" }}
                        onKeyDown={(e) => handlePaymodeKeyDown(e)}
                      ></textarea>
                      {errorMessage.remarks && (
                        <small className="text-danger">
                          {errorMessage.remarks}
                        </small>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-danger pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-danger text-right"
                  onClick={handleUpdate}
                >
                  <DeleteIcon/> Trash In
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockOut;
